/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from "react";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Alert from "react-s-alert";
// import services
import AdminService from "../../services/AdminService";
import GeneralService from "../../services/GeneralService";

// context imports
import { ThemeContext } from "../../contexts/ThemeContext";

// local imports
import ErrorBoundary from "../general/ErrorBoundary";

import Papa from "papaparse";

const AddCounsellorSpreadsheet = (props) => {
  // variables
  let timeout = 0;

  //stats
  const [isLoading, setIsLoading] = useState(false);
  const [suggestionModal, setSuggestionModal] = useState(false);
  const [isImported, setIsImported] = useState(false);

  // const [confirmationModal, setConfirmationModal] = useState({ isVisible: false});
  // const [profiles,setProfiles] = useState(data);
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    searchVal: "",
  });
  const [dataToShow, setDataToShow] = useState([]);

  // State to store parsed data
  const [parsedData, setParsedData] = useState([]);

  //State to store table Column name
  const [tableRows, setTableRows] = useState([]);

  //State to store the values
  const [values, setValues] = useState([]);
  const [sizeOfData, setSizeOfData] = useState(0);
  const [maxPages, setMaxPages] = useState(0);
  const [tempEntry, setTempEntry] = useState(0);

  // contexts
  const { theme } = useContext(ThemeContext);

  // const paginate = (data) => {
  //     pagination.page = Math.ceil(data.length / pagination.limit)

  //     const newData = Array.from({length:pagination.page},(_,index)=>{
  //         const start = index * pagination.limit
  //         return data.slice(start,start + pagination.limit)
  //     })
  //     return newData
  // }

  useEffect(() => {
    const limit = pagination.limit;
    const page = pagination.page;
    const totalPages = Math.ceil(sizeOfData / limit);
    setMaxPages(totalPages);
    // const newData = Array.from({ length: totalPages }, (_) => {
    //     return parsedData.slice((page - 1) * limit, ((page - 1) * limit) + limit)
    // })
    const newData = Array.from(
      parsedData.slice((page - 1) * limit, (page - 1) * limit + limit)
    );
    // console.log(limit, page);
    setDataToShow(newData);
    setPagination({ limit: limit, page: page });
  }, [pagination.page, parsedData, sizeOfData]);

  const handleImportSpreadsheet = () => {
    setSuggestionModal(false);
    document.getElementById("spreadsheetImportBtn").click();
  };

  const handleSpreadsheet = (event) => {
    Papa.parse(event.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        let rowsArray = [];
        let valuesArray = [];

        Promise.all(
          results.data.map((d) => {
            d.phone = d.phone.replace(/^0/, "");
            d.phone = d.phone.replace(/\s/g, "");
            rowsArray.push(Object.keys(d));
            valuesArray.push(Object.values(d));
          })
        );

        setParsedData(results.data);
        setDataToShow(results.data);
        // console.log(results.data.length);
        setSizeOfData(results.data.length);
        setTempEntry(results.data.length);
        // setMaxPages(Math.ceil(sizeOfData / pagination.limit))
        setTableRows(rowsArray[0]);
        setValues(valuesArray);
        setIsImported(true);
      },
    });
  };

  const handleSearch = (e) => {
    try {
      let value = e.target.value;
      let temp = [];
      let tempShowData = [];
      tempShowData = parsedData.map((item, index) => {
        if (item.name.includes(value) || item.uniqueId.includes(value)) {
          temp.push(item);
        }
      });
      setDataToShow(temp);
      setPagination({ ...pagination, searchVal: value });
    } catch (err) {
      Alert.error(
        "Some error occured, please try again later or report support team.",
        {
          position: "top-right",
          effect: "slide",
        }
      );
      GeneralService.logError(
        "at Admin addCounsellorSpreadsheet handleSerach",
        "Error in try catch block",
        err.stack
      );
    }
  };

  const handlePagination = (e, index) => {
    e.preventDefault();
    try {
      setPagination({ ...pagination, page: index });
    } catch (err) {
      Alert.error(
        "Some error occured, please try again later or report support team.",
        {
          position: "top-right",
          effect: "slide",
        }
      );
      GeneralService.logError(
        "at Admin addCounsellorSpreadsheet handlePagination",
        "Error in try catch block",
        err.stack
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      AdminService.postScrapeProviderProfiles(parsedData)
        .then((data) => {
          Alert.info(data.message.msgBody, {
            position: "top-right",
            effect: "slide",
          });
          setIsLoading(false);
          props.history.push("/admin/dashboard/scrapedCounsellorProfiles");
        })
        .catch((error) => {
          Alert.error(error.message.msgBody, {
            position: "top-right",
            effect: "slide",
          });
          setIsLoading(false);
        });
    } catch (err) {
      Alert.error(
        "Some error occured, please try again later or report support team.",
        {
          position: "top-right",
          effect: "slide",
        }
      );
      GeneralService.logError(
        "at Admin AddCounsellorProfileIndividual handleSubmit",
        "Error in try catch block",
        err.stack
      );
      setIsLoading(false);
      console.log(err);
    }
    setIsImported(false);
  };

  return (
    <div className="container-fluid">
      <h3 className="my-4">Add Counsellor Profile</h3>
      <hr />
      <div className="wrapper text-center">
        <div
          className="btn-group"
          py
          style={{ marginLeft: "auto", marginRight: "auto" }}
          role="group"
          aria-label="Basic example"
        >
          <Button
            type="button"
            outline
            onClick={() => {
              props.history.push(
                "/admin/dashboard/addCounsellorProfileIndividual"
              );
            }}
            className="btn border"
          >
            Individual
          </Button>
          <Button type="button" className="btn border">
            Spreadsheet
          </Button>
        </div>
      </div>
      {!isImported && (
        <div className="my-5 text-center">
          <Button outline onClick={() => setSuggestionModal(true)}>
            + Click here to import Spreadsheet
          </Button>
          <input
            hidden
            type="file"
            id="spreadsheetImportBtn"
            name="spreadsheetImportBtn"
            accept=".csv"
            onChange={handleSpreadsheet}
          />
        </div>
      )}
      {isImported && (
        <div className="card mb-4 my-4">
          <div className="card-header d-flex">
            <label className="my-auto">Preview Profiles</label>
          </div>
          <div className="card-body py-0">
            <div className="table-responsive">
              <table
                className="table table-bordered mb-0"
                width="100%"
                cellSpacing="0"
              >
                <thead>
                  <tr>
                    <td colSpan="7" className="border-0 px-0">
                      <div className="d-flex">
                        <div className="ml-auto">
                          <span className="mr-1">Search</span>
                          <input
                            type="text"
                            id="searchInput"
                            className="ml-2"
                            style={{
                              marginRight: "-20px",
                              paddingRight: "20px",
                              overflowX: "hidden",
                            }}
                            onChange={handleSearch}
                          ></input>
                          <span
                            style={{
                              cursor: "pointer",
                              marginRight: "7px",
                              alignSelf: "center",
                              zIndex: 100,
                            }}
                            onClick={() => {
                              document.getElementById("searchInput").value = "";
                              setPagination({ ...pagination, searchVal: "" });
                            }}
                          >
                            <i className="fa fa-times"></i>
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>Unique Id</th>
                    <th>Name</th>
                    <th>Address</th>
                    <th>Phone</th>
                    <th>Website</th>
                  </tr>
                </thead>
                <tbody>
                  {dataToShow.map((value, index) => (
                    <tr>
                      <td key={index}>{value.uniqueId}</td>
                      <td key={index}>{value.name}</td>
                      <td key={index}>{value.address}</td>
                      <td key={index}>{value.phone}</td>
                      <td key={index}>{value.website}</td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <td colSpan="7" className="border-0 pb-0 px-0">
                      <div className="d-flex">
                        <ErrorBoundary errorAt="At Admin ServiceRequests Pagination">
                          <div className="p-2">
                            Showing{" "}
                            {tempEntry == 0
                              ? 0
                              : 1 + 10 * (pagination.page - 1)}{" "}
                            to{" "}
                            {pagination.limit + 10 * (pagination.page - 1) >
                            tempEntry
                              ? tempEntry
                              : pagination.limit +
                                10 * (pagination.page - 1)}{" "}
                            of {tempEntry} entries
                          </div>
                          <Pagination
                            aria-label="Page navigation example"
                            className="ml-auto"
                          >
                            <PaginationItem disabled={pagination.page == 1}>
                              <PaginationLink
                                onClick={(e) =>
                                  handlePagination(e, pagination.page - 1)
                                }
                                previous
                                href="#"
                              />
                            </PaginationItem>
                            {[...Array(maxPages)].map((page, i) => (
                              <PaginationItem
                                active={i + 1 === pagination.page}
                                key={i}
                              >
                                <PaginationLink
                                  onClick={(e) => handlePagination(e, i + 1)}
                                  href="#"
                                >
                                  {i + 1}
                                </PaginationLink>
                              </PaginationItem>
                            ))}
                            <PaginationItem
                              disabled={pagination.page == maxPages}
                            >
                              <PaginationLink
                                onClick={(e) =>
                                  handlePagination(e, pagination.page + 1)
                                }
                                next
                                href="#"
                              />
                            </PaginationItem>
                          </Pagination>
                        </ErrorBoundary>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      )}
      {isImported && (
        <Button
          className="btn"
          style={{ backgroundColor: "#ffd800" }}
          onClick={handleSubmit}
          type="submit"
        >
          Add Profile
        </Button>
      )}

      <Modal size="lg" isOpen={suggestionModal} backdrop={true}>
        <ModalHeader
          close={
            <span
              className="ml-3"
              style={{ cursor: "pointer" }}
              onClick={() => setSuggestionModal(false)}
            >
              <i className="fas fa-times"></i>
            </span>
          }
        >
          {/* <span style={theme.headingBold}>Data</span> */}
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <span>
              Make sure that CSV file you import has to follow below format
              otherwise you will not be able to import it.
            </span>
          </div>
          <div className="table-responsive">
            <table
              className="table table-bordered mb-0"
              width="100%"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th>UniqueId</th>
                  <th>Name</th>
                  <th>Address</th>
                  <th>Phone</th>
                  <th>Website</th>
                </tr>
              </thead>
              <tbody>
                {[1, 2].map((value, index) => (
                  <tr>
                    <td key={index}>UniqueId{value}</td>
                    <td key={index}>Name{value}</td>
                    <td key={index}>Address{value}</td>
                    <td key={index}>Phone{value}</td>
                    <td key={index}>Website{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            style={theme.formButton}
            onClick={() => handleImportSpreadsheet()}
          >
            Understood!
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AddCounsellorSpreadsheet;
